// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.divider {\n  background-color: #ccc;\n  width: 100%;\n  height: 1px;\n  margin: 10px 0 20px 0;\n}\n.addBtn {\n  padding: 10px 0;\n  color: #00A551;\n  font-size: 12px;\n  text-align: center;\n  cursor: pointer\n}\n", ""]);
// Exports
module.exports = exports;
